import { useReveal } from "@/hooks/useReveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ITEMS = [
  { q: "Нужно скачивать приложение?", a: "Нет. Оно открывается прямо в браузере телефона." },
  { q: "Регистрация платная?", a: "Нет. Полностью бесплатная." },
  { q: "Сколько времени занимает регистрация?", a: "Около одной минуты." },
  { q: "Когда начисляются бонусы?", a: "Сразу после завершения регистрации." },
  { q: "Где находится бутик?", a: "Алматы, Нурлы Тау. Адрес бутика: ТЦ «Jurek Tau», этаж P1. Телефон: +7 701 801 77 55." },
];

export const Faq = () => {
  const ref = useReveal();
  return (
    <section id="faq" ref={ref} data-testid="faq-section" className="py-28 md:py-36" style={{ background: "var(--paper)" }}>
      <div className="pw-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <div>
            <span className="pw-eyebrow reveal">FAQ</span>
            <h2 className="pw-h2 reveal mt-6 max-w-md">Частые вопросы.</h2>
          </div>
          <div className="reveal">
            <Accordion type="single" collapsible className="w-full">
              {ITEMS.map((item, i) => (
                <AccordionItem key={i} value={`q-${i}`} data-testid={`faq-item-${i}`} className="faq-item">
                  <AccordionTrigger className="text-left text-[16px] font-semibold hover:no-underline py-6" style={{ letterSpacing: "-0.01em" }}>
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed" style={{ color: "var(--grey-1)" }}>
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
